import React from 'react';


const FoodSafetyDashboard: React.FC = () => {
    const [showOpeningChecks, setShowOpeningChecks] = React.useState(false);

    return (
        <div className="flex h-screen bg-gray-100 relative">
            {/* Modal Overlay */}
            {showOpeningChecks && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="w-full max-w-2xl">
                        {/* Dynamic Import to avoid cyclic dependencies if any */}
                        <React.Suspense fallback={<div>Loading...</div>}>
                            <OpeningChecksWrapper
                                establishmentId="est_demo_1"
                                onClose={() => setShowOpeningChecks(false)}
                            />
                        </React.Suspense>
                    </div>
                </div>
            )}

            <div className="flex-1 flex flex-col overflow-hidden">
                <header className="flex justify-between items-center py-4 px-6 bg-white border-b-4 border-orange-600">
                    <div className="flex items-center">
                        <h1 className="text-2xl font-bold text-gray-800">Food Safety Dashboard</h1>
                    </div>
                    <div className="flex items-center space-x-4">
                        <button
                            onClick={() => setShowOpeningChecks(true)}
                            className="bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded-lg flex items-center shadow-md transition"
                        >
                            <i className="fas fa-clipboard-check mr-2"></i>
                            Start Opening Checks
                        </button>
                        <button
                            onClick={() => {
                                import('../../services/cognito').then(({ signOut }) => {
                                    signOut();
                                    window.location.href = '/login';
                                });
                            }}
                            className="text-gray-600 hover:text-gray-900 font-medium px-4 py-2"
                        >
                            Sign Out
                        </button>
                    </div>
                </header>
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
                    <div className="max-w-7xl mx-auto">
                        <div className="bg-white rounded-lg shadow-md p-6">
                            <h2 className="text-xl font-semibold mb-4">Welcome to Food Safety Pro</h2>
                            <p className="text-gray-600 mb-6">
                                Your digital food safety diary is active.
                            </p>

                            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                                <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
                                    <h3 className="font-bold text-orange-800">Establishments</h3>
                                    <p className="text-2xl mt-2 font-bold">1</p>
                                </div>
                                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                    <h3 className="font-bold text-blue-800">Checks Today</h3>
                                    <p className="text-2xl mt-2 font-bold">0</p>
                                </div>
                                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                    <h3 className="font-bold text-green-800">Compliance Score</h3>
                                    <p className="text-2xl mt-2 font-bold">100%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

// Lazy load to keep initial bundle small
const OpeningChecksWrapper = React.lazy(() => import('./OpeningChecks').then(module => ({ default: module.default })));


export default FoodSafetyDashboard;
